export const storageKey = 'tasks';
export const taskTypes = ['Development', 'Testing', 'Meeting', 'Deployment'];
export const ADD       = "add";
export const SUBTRACT  = "subtract";
export const HOUR      = 60;
export const RED       = 4*HOUR;
export const GREEN     = 8*HOUR;
